// extracted by mini-css-extract-plugin
module.exports =  {"selected-wrapper":"bottomPanel__selected-wrapper"};